var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{ checked: _vm.checked, column: !_vm.$slots.icon },on:{"click":function($event){return _vm.$emit('tag-click')}}},[_c('div',{staticClass:"text text-overflow"},[_vm._v(" "+_vm._s(_vm.tag.name)+" ")]),(_vm.$slots.icon)?_c('div',{staticClass:"icon-wrapper"},[_vm._t("icon")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }